import { QuestionnaireConfigState } from "@teamprevent/common/questionnaires/questionnaireConfig/models";
import { questionnaireConfig as reducer } from "@teamprevent/common/questionnaires/questionnaireConfig/reducer";

import { Base } from "./components/Base";

export {
    Base,
    QuestionnaireConfigState,
    reducer
};
